//#region src/generated/schemas.gen.ts
var e = {
	type: "string",
	enum: ["MINUTES"]
}, t = {
	type: "object",
	properties: {
		distributionParty: {
			type: "string",
			enum: [
				"BOL",
				"RETAILER",
				"ALL"
			]
		},
		fulfilmentMethod: {
			type: "string",
			enum: [
				"FBR",
				"FBB",
				"ALL"
			]
		}
	},
	required: ["distributionParty", "fulfilmentMethod"]
}, n = {
	type: "object",
	properties: {
		id: {
			type: "string",
			format: "uuid",
			description: "The sales channel ID."
		},
		createdAt: {
			type: "string",
			format: "date-time",
			description: "Sales channel created at."
		},
		extraction: {
			type: "object",
			properties: {
				strategy: { $ref: "#/components/schemas/ExtractionStrategy" },
				lastCycle: {
					type: "object",
					properties: {
						extractedAt: {
							type: "string",
							format: "date-time",
							description: "Last order extraction attempt at."
						},
						successfullyExtractedAt: {
							type: "string",
							format: "date-time",
							description: "Last successful order extraction at."
						},
						transformedAndLoadedAt: {
							type: "string",
							format: "date-time",
							description: "Last order extraction and loading attempt at."
						},
						successfullyTransformedAndLoadedAt: {
							type: "string",
							format: "date-time",
							description: "Last successful order extraction and loading at."
						}
					},
					description: "Last order extraction cycle."
				}
			},
			required: ["strategy"],
			description: "Order extraction configuration."
		},
		fulfilmentPlatforms: {
			type: "array",
			items: {
				type: "string",
				enum: ["VASCO"],
				description: "The fulfilment platform."
			},
			minItems: 1,
			description: "Fulfilment platforms."
		},
		name: {
			type: "string",
			minLength: 3,
			maxLength: 50,
			description: "Custom sales channel name."
		},
		shopId: {
			type: "string",
			minLength: 1,
			maxLength: 50,
			description: "Owning shop ID for the sales channel."
		},
		authorizeUrl: {
			type: "string",
			format: "uri",
			description: "Authorization URL for the sales channel."
		},
		status: {
			type: "string",
			enum: ["DELEGATION_REQUESTED"],
			description: "Connection status which indicates that a connection authorization has been requested but not yet confirmed."
		}
	},
	required: [
		"id",
		"createdAt",
		"extraction",
		"name",
		"shopId",
		"authorizeUrl",
		"status"
	]
}, r = {
	type: "object",
	properties: {
		id: {
			type: "string",
			format: "uuid",
			description: "The sales channel ID."
		},
		createdAt: {
			type: "string",
			format: "date-time",
			description: "Sales channel created at."
		},
		extraction: {
			type: "object",
			properties: {
				strategy: { $ref: "#/components/schemas/ExtractionStrategy" },
				lastCycle: {
					type: "object",
					properties: {
						extractedAt: {
							type: "string",
							format: "date-time",
							description: "Last order extraction attempt at."
						},
						successfullyExtractedAt: {
							type: "string",
							format: "date-time",
							description: "Last successful order extraction at."
						},
						transformedAndLoadedAt: {
							type: "string",
							format: "date-time",
							description: "Last order extraction and loading attempt at."
						},
						successfullyTransformedAndLoadedAt: {
							type: "string",
							format: "date-time",
							description: "Last successful order extraction and loading at."
						}
					},
					description: "Last order extraction cycle."
				}
			},
			required: ["strategy"],
			description: "Order extraction configuration."
		},
		fulfilmentPlatforms: {
			type: "array",
			items: {
				type: "string",
				enum: ["VASCO"],
				description: "The fulfilment platform."
			},
			minItems: 1,
			description: "Fulfilment platforms."
		},
		name: {
			type: "string",
			minLength: 3,
			maxLength: 50,
			description: "Custom sales channel name."
		},
		shopId: {
			type: "string",
			minLength: 1,
			maxLength: 50,
			description: "Owning shop ID for the sales channel."
		},
		delegationError: {
			type: "object",
			properties: {
				reason: {
					type: "string",
					description: "Error reason."
				},
				details: {
					type: "string",
					description: "More detailed information about the error."
				}
			},
			required: ["reason"],
			description: "Delegation error."
		},
		status: {
			type: "string",
			enum: ["DELEGATION_REQUIRED"],
			description: "Connection status which indicates that a connection authorization is required."
		}
	},
	required: [
		"id",
		"createdAt",
		"extraction",
		"name",
		"shopId",
		"delegationError",
		"status"
	]
}, i = {
	type: "object",
	properties: {
		type: {
			type: "string",
			enum: [
				"about:blank",
				"urn:problem:client",
				"urn:problem:invalid-request-syntax",
				"urn:problem:not-found",
				"urn:problem:server",
				"urn:problem:unauthorized",
				"urn:problem:unsupported-media-type"
			],
			description: "A URI reference that identifies the problem type."
		},
		status: {
			type: "integer",
			enum: [
				400,
				401,
				404,
				415,
				500
			],
			description: "The HTTP status code generated by the origin server."
		},
		title: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "A short human-readable summary of the problem type."
		},
		detail: {
			type: "string",
			minLength: 1,
			maxLength: 5e3,
			description: "A human-readable explanation specific to this occurrence of the problem."
		},
		instance: {
			type: "string",
			format: "uri",
			description: "A URI reference that identifies the specific occurrence of the problem."
		},
		cause: { description: "The cause of this problem when debug mode is enabled." }
	},
	required: [
		"type",
		"status",
		"title",
		"detail",
		"instance"
	]
}, a = { allOf: [{ $ref: "#/components/schemas/ProblemDetails" }, {
	type: "object",
	properties: {
		type: {
			type: "string",
			enum: ["urn:problem:invalid-request-syntax"],
			description: "A URI reference that identifies the problem type."
		},
		status: {
			type: "number",
			enum: [400],
			description: "The HTTP status code generated by the origin server."
		},
		errors: {
			type: "array",
			items: {
				type: "object",
				properties: {
					detail: {
						type: "string",
						minLength: 1,
						maxLength: 5e3
					},
					pointer: {
						type: "string",
						minLength: 1,
						maxLength: 200,
						description: "This is a JSON pointer to the request (body, parameters, ...). When an aggregate has a conflict (e.g. not allowed due to the status) this value is for bulk request on the index (/body/{index}) and for any other on root (/)."
					}
				},
				required: ["detail", "pointer"]
			},
			minItems: 1,
			description: "Detailed information regarding the syntactic violations."
		}
	},
	required: ["errors"]
}] }, o = {
	type: "object",
	properties: {
		extractionStrategy: { $ref: "#/components/schemas/ExtractionStrategy" },
		fulfilmentPlatforms: {
			type: "array",
			items: {
				type: "string",
				enum: ["VASCO"],
				description: "The fulfilment platform."
			},
			minItems: 1,
			maxItems: 1,
			description: "The fulfilment platforms."
		},
		name: {
			type: "string",
			minLength: 3,
			maxLength: 50,
			description: "The name of the sales channel."
		},
		shopId: {
			type: "string",
			minLength: 1,
			maxLength: 50,
			description: "The shop ID."
		}
	},
	required: [
		"extractionStrategy",
		"name",
		"shopId"
	],
	examples: [{
		extractionStrategy: {
			distributionParty: "ALL",
			fulfilmentMethod: "ALL"
		},
		fulfilmentPlatforms: ["VASCO"],
		name: "My Bol sales channel",
		shopId: "1234"
	}]
}, s = {
	type: "object",
	properties: {
		id: {
			type: "string",
			format: "uuid",
			description: "The sales channel ID."
		},
		createdAt: {
			type: "string",
			format: "date-time",
			description: "Sales channel created at."
		},
		extraction: {
			type: "object",
			properties: {
				strategy: { $ref: "#/components/schemas/ExtractionStrategy" },
				lastCycle: {
					type: "object",
					properties: {
						extractedAt: {
							type: "string",
							format: "date-time",
							description: "Last order extraction attempt at."
						},
						successfullyExtractedAt: {
							type: "string",
							format: "date-time",
							description: "Last successful order extraction at."
						},
						transformedAndLoadedAt: {
							type: "string",
							format: "date-time",
							description: "Last order extraction and loading attempt at."
						},
						successfullyTransformedAndLoadedAt: {
							type: "string",
							format: "date-time",
							description: "Last successful order extraction and loading at."
						}
					},
					description: "Last order extraction cycle."
				},
				schedule: {
					type: "object",
					properties: {
						transformAndLoad: {
							type: "boolean",
							description: "Whether orders should be automatically imported."
						},
						unit: { allOf: [{ $ref: "#/components/schemas/ExtractionScheduleUnit" }, { description: "Time unit which is used for scheduled order loading." }] },
						value: {
							type: "integer",
							exclusiveMinimum: 0,
							description: "Amount of time units between each scheduled order loading attempt."
						}
					},
					required: [
						"transformAndLoad",
						"unit",
						"value"
					],
					description: "Schedule which is used for order loading."
				}
			},
			required: ["strategy", "schedule"],
			description: "Order extraction configuration."
		},
		fulfilmentPlatforms: {
			type: "array",
			items: {
				type: "string",
				enum: ["VASCO"],
				description: "The fulfilment platform."
			},
			minItems: 1,
			description: "Fulfilment platforms."
		},
		name: {
			type: "string",
			minLength: 3,
			maxLength: 50,
			description: "Custom sales channel name."
		},
		shopId: {
			type: "string",
			minLength: 1,
			maxLength: 50,
			description: "Owning shop ID for the sales channel."
		},
		status: {
			type: "string",
			enum: ["DELEGATION_ISSUED"],
			description: "Status for the connection with the sales channel for which orders will be extracted from."
		}
	},
	required: [
		"id",
		"createdAt",
		"extraction",
		"name",
		"shopId",
		"status"
	]
}, c = {
	type: "object",
	properties: { salesChannelId: {
		type: "string",
		format: "uuid",
		description: "The sales channel ID."
	} },
	required: ["salesChannelId"],
	examples: [{ salesChannelId: "3fa85f64-5717-4562-b3fc-2c963f66afa6" }]
}, l = {
	type: "object",
	properties: { salesChannelId: {
		type: "string",
		format: "uuid",
		description: "The sales channel ID."
	} },
	required: ["salesChannelId"],
	examples: [{ salesChannelId: "3fa85f64-5717-4562-b3fc-2c963f66afa6" }]
}, u = {
	type: "object",
	properties: { salesChannelIds: {
		type: "array",
		items: {
			type: "string",
			format: "uuid"
		},
		minItems: 1,
		maxItems: 150,
		description: "The sales channel id to import products for"
	} },
	required: ["salesChannelIds"]
}, d = {
	oneOf: [
		{ $ref: "#/components/schemas/SalesChannelWithStatusDelegationRequired" },
		{ $ref: "#/components/schemas/SalesChannelWithStatusDelegationIssued" },
		{ $ref: "#/components/schemas/SalesChannelWithStatusDelegationRequested" }
	],
	discriminator: {
		propertyName: "status",
		mapping: {
			DELEGATION_REQUIRED: "#/components/schemas/SalesChannelWithStatusDelegationRequired",
			DELEGATION_ISSUED: "#/components/schemas/SalesChannelWithStatusDelegationIssued",
			DELEGATION_REQUESTED: "#/components/schemas/SalesChannelWithStatusDelegationRequested"
		}
	}
}, f = {
	type: "object",
	properties: {
		salesChannelId: {
			type: "string",
			format: "uuid",
			description: "The sales channel ID."
		},
		fulfilmentPlatforms: {
			type: "array",
			items: {
				type: "string",
				enum: ["VASCO"],
				description: "The fulfilment platform."
			},
			minItems: 1,
			maxItems: 1,
			description: "The fulfilment platforms."
		}
	},
	required: ["salesChannelId"],
	examples: [{
		salesChannelId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
		fulfilmentPlatforms: ["VASCO"]
	}]
}, p = {
	type: "object",
	properties: { salesChannelId: {
		type: "string",
		format: "uuid",
		description: "The ID of the sales channel."
	} },
	required: ["salesChannelId"],
	examples: [{ salesChannelId: "3fa85f64-5717-4562-b3fc-2c963f66afa6" }]
}, m = {
	type: "object",
	properties: {
		salesChannelId: {
			type: "string",
			format: "uuid",
			description: "The ID of the sales channel."
		},
		name: {
			type: "string",
			minLength: 3,
			maxLength: 50,
			description: "The name of the sales channel."
		}
	},
	required: ["salesChannelId", "name"],
	examples: [{
		salesChannelId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
		name: "New sales channel name"
	}]
}, h = { allOf: [{ $ref: "#/components/schemas/ProblemDetails" }, {
	type: "object",
	properties: {
		type: {
			type: "string",
			enum: ["urn:problem:not-found"],
			description: "A URI reference that identifies the problem type."
		},
		status: {
			type: "number",
			enum: [404],
			description: "The HTTP status code generated by the origin server."
		}
	}
}] }, g = {
	type: "object",
	properties: { salesChannelId: {
		type: "string",
		format: "uuid",
		description: "The sales channel ID."
	} },
	required: ["salesChannelId"],
	examples: [{ salesChannelId: "3fa85f64-5717-4562-b3fc-2c963f66afa6" }]
};
//#endregion
export { r as _, t as a, a as c, p as d, m as f, n as g, s as h, e as i, h as l, d as m, c as n, u as o, g as p, l as r, f as s, o as t, i as u };
